// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const quaxly: PokeData = {
  "id": 912,
  "name": "quaxly",
  "height": 5,
  "weight": 61,
  "base_experience": 62,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "wing-attack",
    "growl",
    "water-gun",
    "focus-energy",
    "air-slash",
    "aqua-jet",
    "double-hit",
    "acrobatics",
    "work-up",
    "liquidation",
    "aqua-cutter"
  ],
  "moves": [
    "growl",
    "air-slash",
    "aqua-jet",
    "acrobatics",
    "liquidation",
    "aqua-cutter",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "brine",
    "rain-dance",
    "whirlpool",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 480,
    "item": null,
    "species": [
      {
        "name": "quaxly",
        "order": 912,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quaxwell",
        "order": 913,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 912,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "quaquaval",
        "order": 914,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 913,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 50,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
